import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router';
import { RTL_LANGUAGES } from './i18n/index.ts';
import { router } from './router.tsx';

export default function App() {
  const { i18n } = useTranslation();

  // Apply RTL direction to <html> element when locale changes
  useEffect(() => {
    const lang = i18n.language as string;
    const isRtl = (RTL_LANGUAGES as readonly string[]).includes(lang.split('-')[0] ?? '');
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [i18n.language]);

  return <RouterProvider router={router} />;
}
